/* eslint-disable no-unused-vars */
/* eslint-disable eqeqeq */

import { Radio, TableCell, TableRow, Typography } from '@mui/material'
import React, { useState } from 'react'
import { useQeustion } from '../../context/QuestionContext/QuestionContext'

const DISCAnswer = ({ questionNo, options, form }) => {
  const question = useQeustion()
  const [pSelection, setPSelection] = useState(null)
  const [kSelection, setKSelection] = useState(null)
  const [answer, setAnswer] = useState({})

  const onChangeP = (e) => {
    if (e.target.value == kSelection) {
      return
    }
    setPSelection(e.target.value)
    setAnswer((prev) => ({
      ...prev,
      [`p${question.current}`]: e.target.value,
    }))
    form.setValue(`p${question.current}`, e.target.value)
  }

  const onChangeK = (e) => {
    if (e.target.value == pSelection) {
      return
    }
    setKSelection(e.target.value)
    setAnswer((prev) => ({
      ...prev,
      [`k${question.current}`]: e.target.value,
    }))
    form.setValue(`k${question.current}`, e.target.value)
  }

  return (
    <>
      <TableRow>
        <TableCell
          sx={{
            '&.MuiTableCell-root ': { width: '248px' },
          }}
        >
          <Typography fontWeight={200}>{options[0].value}</Typography>
        </TableCell>
        <TableCell>
          <Radio value={1} checked={pSelection == 1} onChange={onChangeP} />
        </TableCell>
        <TableCell>
          <Radio value={1} checked={kSelection == 1} onChange={onChangeK} />
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell>
          <Typography fontWeight={200}>{options[1].value}</Typography>
        </TableCell>
        <TableCell>
          <Radio value={2} checked={pSelection == 2} onChange={onChangeP} />
        </TableCell>
        <TableCell>
          <Radio value={2} checked={kSelection == 2} onChange={onChangeK} />
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell>
          <Typography fontWeight={200}>{options[2].value}</Typography>
        </TableCell>
        <TableCell>
          <Radio value={3} checked={pSelection == 3} onChange={onChangeP} />
        </TableCell>
        <TableCell>
          <Radio value={3} checked={kSelection == 3} onChange={onChangeK} />
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell>
          <Typography fontWeight={200}>{options[3].value}</Typography>
        </TableCell>
        <TableCell>
          <Radio value={4} checked={pSelection == 4} onChange={onChangeP} />
        </TableCell>
        <TableCell>
          <Radio value={4} checked={kSelection == 4} onChange={onChangeK} />
        </TableCell>
      </TableRow>
    </>
  )
}

export default DISCAnswer
